<template>
  <div ref='app' id="app">
    <NavBar ref='navBar' @transChild='transChild' v-show='showNav'/>
    <div id='route-content' ref='routeContent' :style="getNavBarHeight()">
      <keep-alive include="esports-debug">
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'

export default {
  components: {
    NavBar
  },
  data () {
    return {
      needTrans: false,
      showNav: false
    }
  },
  methods: {
    transChild (needTrans) {
      this.$refs.routeContent.style.position = needTrans ? 'relative' : 'static'
      this.needTrans = needTrans
    },
    getNavBarHeight () {
      let styleName = this.needTrans ? 'margin-top' : 'top'
      if (this.$route.params.statusbarheight > 0 || parseInt(this.$route.query.statusbarheight) > 0) {
        let barHeight = parseInt(this.$route.params.statusbarheight) > 0 ? parseInt(this.$route.params.statusbarheight) : parseInt(this.$route.query.statusbarheight)
        this.$route.params.NavBarHeight = 44 + barHeight
        return `${styleName}: ${0 - (44 + barHeight)}px`
      } else {
        this.$route.params.NavBarHeight = '44'
        return `${styleName}: -44px`
      }
    }
  },
  watch: {
    $route (to, from) {
      this.showNav = this.$route.params.statusbarheight !== undefined
    }
  }
}
</script>

<style lang="sass" scoped>
#route-content
  margin-bottom: 40px

*
  font-family: PingFangSC-Regular, sans-serif
</style>
